/* Preserve Beauty - shared scroll-reveal controller.
   Safe to include on every section; initializes once per page. */
(function () {
  if (window.__pbScrollRevealInit) return;
  window.__pbScrollRevealInit = true;

  function init() {
    var targets = document.querySelectorAll('.reveal, .fade-up');
    if (!('IntersectionObserver' in window) || !targets.length) {
      targets.forEach(function (el) { el.classList.add('in-view'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    targets.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan when Shopify section editor injects/reloads sections
  document.addEventListener('shopify:section:load', init);
})();
